import { createSelector } from 'reselect';
import { ROOT_SLICE } from './constants';
import { selectRootSliceAdmin } from '../../../Main/selectors';


export const selectRootSlice = (state) => { 
  const stateAdmin = selectRootSliceAdmin(state);
  if (stateAdmin[ROOT_SLICE]) { 
    return stateAdmin[ROOT_SLICE];
  }

  // else assume state is this slice.
  return state;
};


export const selectData = state => {
	const slice = selectRootSlice(state);
	const { data } = slice;
	return data;
};

export const selectBoolMap = state => {
	const slice = selectRootSlice(state);
	const { boolMap } = slice;
	return boolMap;
};

export const selectDataMap = state => {
	const slice = selectRootSlice(state);
	const { dataMap } = slice;
	return dataMap;
};

export const selectHasDataMap = state => {
	const slice = selectRootSlice(state);
	const { hasDataMap } = slice;
	return hasDataMap;
};

export const selectIsLoading = state => {
	const slice = selectRootSlice(state);
	const { isLoading } = slice;
	return isLoading;
};

export const selectIsLoaded = state => {
	const slice = selectRootSlice(state);
	const { isLoaded } = slice;
	return isLoaded;
};

export const selectErrorMessage = state => {
	const slice = selectRootSlice(state);
	const { errorMessage } = slice;
	return errorMessage;
};

export const selectMapCustomerObjectByName = createSelector(
  selectData,
  (data) => {
    return (data || []).reduce((acc, customer) => {
      acc[customer.name] = customer;
      return acc;
    }, {});
  }
);


export const selectDomain = (state, { customerName }) => { 
  const map = selectMapCustomerObjectByName(state) || [];
  return map[customerName]?.domain;
}

export const selectCustomerCreatedJobNumberPrefix = (state, { customerName }) => {
  const map = selectMapCustomerObjectByName(state) || [];
  return map[customerName]?.customerCreatedJobNumberPrefix;
};


export default {
	selectData,
	selectBoolMap,
	selectDataMap,
	selectHasDataMap,
	selectIsLoading,
	selectIsLoaded,
  selectErrorMessage,
  
  selectDomain,
  selectCustomerCreatedJobNumberPrefix
};
